/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';

import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    color: 'red !important',
  },
}));

export default function ColorTabs(props) {
  const classes = useStyles();
  const {
    tabValue,
    datesTabError,
    planContatTabError,
    errorMessagesArray,
    handleChangeTabValue,
  } = props;
  return (
    <>
      <div className={classes.root}>
        <AppBar
          position="static"
          sx={{ width: '100%' }}
          style={{ borderBottom: '1px solid #c9c8c5' }}
        >
          <Tabs
            value={tabValue}
            onChange={handleChangeTabValue}
            color="red"
            style={{ color: 'red' }}
          >
            <Tab
              style={{ textTransform: 'capitalize' }}
              value="one"
              label="Dates"
              tabIndex={0}
            />
            {(datesTabError ||
              (errorMessagesArray &&
                errorMessagesArray.length > 0 &&
                errorMessagesArray.filter((x) => {
                  return x === constantMessageData.START_DATE_REQUIRED;
                }).length > 0)) && <span className="tab-error">!</span>}
            <Tab
              style={{ textTransform: 'capitalize' }}
              value="two"
              label="Plan Contact"
              tabIndex={0}
            />
            {(planContatTabError ||
              (errorMessagesArray &&
                errorMessagesArray.length > 0 &&
                errorMessagesArray.filter((x) => {
                  return (
                    x === constantMessageData.NAME_REQUIRED ||
                    x === constantMessageData.CONTACT_TYPE_REQUIRED ||
                    x === constantMessageData.ADDRESS_LINE1_REQUIRED ||
                    x === constantMessageData.CITY_REQUIRED ||
                    x === constantMessageData.STATE_REQUIRED ||
                    x === constantMessageData.ZIP_REQUIRED ||
                    x === constantMessageData.ZIP4_REQUIRED ||
                    x === constantMessageData.PHONE_REQUIRED ||
                    x === constantMessageData.PHONE_INVALID_ERROR ||
                    x === constantMessageData.EMAIL_REQUIRED ||
                    x === constantMessageData.EMAIL_INVALID
                  );
                }).length > 0)) && <span className="tab-error">!</span>}
          </Tabs>
        </AppBar>
      </div>
    </>
  );
}
